import { times } from 'lodash';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

interface PaginationProps {
  activeElement: number;
  numberOfElements: number;
  onClickCallback: (index: number) => void;
}

const Pagination = ({
  activeElement,
  numberOfElements,
  onClickCallback,
}: PaginationProps) => (
  <StyledPagination>
    <Dots>
      {times(numberOfElements, (index) => (
        <DotContainer
          aria-label={`pagination dot ${index + 1}`}
          data-testid="builder-pagination"
          onKeyPress={() => onClickCallback(index)}
          onClick={() => onClickCallback(index)}
          tabIndex={0}
          role="button"
          key={index}
        >
          <Dot $isActive={activeElement === index} />
        </DotContainer>
      ))}
    </Dots>
  </StyledPagination>
);
export default Pagination;

interface DotProps {
  $isActive: boolean;
}

const Dot = styled.div<DotProps>`
  border-radius: 50%;
  background: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.primary : theme.colors.horizon};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
  width: 8px;
  height: 8px;
`;

const DotContainer = styled(Box).attrs(() => ({
  padding: '5px',
}))`
  cursor: pointer;
`;

const Dots = styled(Box).attrs(() => ({
  justifyContent: 'space-between',
}))``;

const StyledPagination = styled(Box).attrs(() => ({
  bottom: '15px',
  justifyContent: 'center',
  position: 'absolute',
  width: '100%',
}))``;
